import Env from "rs-browser";

let appId = "C1C50237";
if (Env.web) {
  appId = "313734E9";
} else if (Env.android) {
  appId = "C7D84F4B";
}

const env = {
  appId,
  path: "https://wap.mmall.com",
  newWap: "https://m.mmall.com",
  couponPath: "https://user-at.mmall.com",
  call_secret: "DC11572CFFEC446285CA6C3708EAEACD",
  ptotocol: "https://",
  // campusUrl: 'https://jobapiprd.oa.chinaredstar.com',
  campusUrl: "https://campus.mmall.com/api-job",
  getweixin: "https://jobchat.mmall.com/config/getjssign",
  shareLink:
    "https://jobchat.mmall.com/OAuth/Index2?returnUrl=https%3a%2f%2fjobchat.mmall.com%2fcampus%2f%23%2fjobdetail%2f",
  shareIndexLink:
    "https://jobchat.mmall.com/OAuth/Index2?returnUrl=https%3a%2f%2fjobchat.mmall.com%2fcampus%2f",
};

window.__config_env = env;



// WEBPACK FOOTER //
// ./config/config.prd.js